<template>
  <div class="channel-nav">
    <div class="d-none d-sm-block">
      <h4>Channels</h4>
      <b-list-group>
        <b-list-group-item disabled
                          v-if="loading">Loading Channels...</b-list-group-item>
        <b-list-group-item v-for="c in channels"
                          :key="c.id"
                          :active="$route.query.channel_id == c.id || $route.params.id == c.id"
                          :href="'#/channels/'+c.id">{{c.name}}</b-list-group-item>
      </b-list-group>
    </div>
    <div class="d-block d-sm-none mb-5">
      <div class="btn-group" style="width:100%">
        <button style="width:100%" id="dLabel" @click="toggleDropdown" type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Browse Channels
        </button>
        <div class="dropdown-menu" aria-labelledby="dLabel" style="width:100%" v-bind:style="{display:menuOpen?'block':'none'}">
          <h6 class="dropdown-header">Channels</h6>
          <a class="dropdown-item" disabled v-if="loading">Loading Channels...</a>
          <a class="dropdown-item" v-for="c in channels"
                  :key="c.id"
                  @click="toggleDropdown" v-bind:class="{active:$route.params.id == c.id}"
                  :href="'#/channels/'+c.id">{{c.name}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from '@/config'
export default {
  name: 'ChannelNav',
  data () {
    return {
      loading: false,
      channels: [],
      menuOpen: false
    }
  },
  mounted () {
    this.getChannels()
  },
  methods: {
    toggleDropdown () {
      this.menuOpen = !this.menuOpen
    },
    getChannels () {
      this.channels = Config.staticChannels
    }
  }
}
</script>

<style>
.channel-nav h4 {
  text-align: left;
  /*margin-top: 30px;*/
  font-size: 12pt;
  text-transform: uppercase;
  opacity: 0.6;
}
.list-group-item {
  text-align: left;
  padding: 10px;
  font-size: 10pt;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/ChannelNav.vue